import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=e324ba0c&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=ts"
export * from "./FilterBox.vue?vue&type=script&lang=ts"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=e324ba0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e324ba0c",
  null
  
)

export default component.exports